class CartUpsell extends HTMLElement {
    constructor() { 
        super();
    }

    connectedCallback() {
        console.log("CART UPSELL ELEMENT INITIALISED");

        this.productForm = this.querySelector('.cart-upsell__form-id');
        if(!this.productForm) return;

        this.submit = this.querySelector('.cart-upsell__product-submit');
        if(!this.submit) return;

        this.submit.addEventListener('click', (e) => {
            e.preventDefault();
            
            console.log("UPSELL SUBMIT TRIGGERED")

            this.addUpsellToCart();
        });
    }

    addUpsellToCart() {
        const cartItems = document.querySelector('cart-items');
        if (!cartItems) return;

        this.submit.classList.add('loading');

        // Get the sections your theme needs to update (drawer, subtotal, etc.)
        const sectionsToUpdate = cartItems.getSectionsToRender();

        const formData = {
            'id': Number(this.getProductID()),
            'quantity': 1,
            'sections': sectionsToUpdate.map((s) => s.section),
            'sections_url': window.location.pathname
        };

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(parsedState => {
            if (parsedState.status) throw new Error(parsedState.description);

            // Logic to update the DOM elements based on cart.js requirements
            sectionsToUpdate.forEach((section) => {
                const elementToReplace = document.getElementById(section.id);
                if (!elementToReplace || !parsedState.sections[section.section]) return;

                const html = new DOMParser().parseFromString(parsedState.sections[section.section], 'text/html');
                const selectors = Array.isArray(section.selector) ? section.selector : [section.selector];

                selectors.forEach(selector => {
                    const target = selector ? elementToReplace.querySelector(selector) : elementToReplace;
                    const source = selector ? html.querySelector(selector) : html.querySelector('.shopify-section');
                    
                    console.log("Source: ", source);

                    if (target && source) {
                        target.innerHTML = source.innerHTML;
                    }
                });

                if (section.callback) section.callback(html);
            });

            // Refresh the bubble and open drawer
            this.renderContents();
        })
        .catch(e => console.error(e))
        .finally(() => {
            this.submit.classList.remove('loading');
        });
    }

    renderContents() {
        // Trigger the opening of the drawer
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        if (cartIconBubble && window.enableCartDrawer) {
            cartIconBubble.dispatchEvent(new Event('triggetClick'));
        }
        
        // Publish event so other components know the cart changed
        if (typeof publish === 'function') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell' });
        }
    }

    getProductID() {
        return this.productForm.value;
    }
}

if(!customElements.get('cart-upsell')) customElements.define('cart-upsell', CartUpsell);